if (!customElements.get('product-description-read-more')) {
  customElements.define(
    'product-description-read-more',
    class ProductDescriptionReadMore extends HTMLElement {
      connectedCallback() {
        this._content = this.querySelector('[data-product-description-content]');
        this._toggle = this.querySelector('[data-product-description-toggle]');
        if (!this._content || !this._toggle) return;

        this._onToggle = this._onToggle.bind(this);
        this._toggle.addEventListener('click', this._onToggle);

        const runInit = () => this._init();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', runInit, { once: true });
        } else {
          requestAnimationFrame(runInit);
        }
        window.addEventListener(
          'load',
          () => {
            if (!this.isConnected || this.classList.contains('is-expanded')) return;
            this._init();
          },
          { once: true }
        );
      }

      disconnectedCallback() {
        this._toggle?.removeEventListener('click', this._onToggle);
      }

      _maxCollapsedPx() {
        const probe = document.createElement('div');
        probe.setAttribute('aria-hidden', 'true');
        probe.style.cssText =
          'position:absolute;left:0;top:0;visibility:hidden;pointer-events:none;height:var(--product-description-collapsed-max,15rem);width:0;';
        this.appendChild(probe);
        const px = probe.offsetHeight;
        probe.remove();
        return px;
      }

      _init() {
        const maxPx = this._maxCollapsedPx();
        this.classList.remove('product-description-read-more--clamped');

        if (this._content.scrollHeight <= maxPx + 1) {
          this._toggle.hidden = true;
          return;
        }

        this.classList.add('product-description-read-more--clamped');
        this._toggle.hidden = false;
        this._toggle.setAttribute('aria-expanded', 'false');

        const more = this._toggle.querySelector('[data-label-more]');
        const less = this._toggle.querySelector('[data-label-less]');
        if (more && less) {
          more.hidden = false;
          less.hidden = true;
        }
      }

      _onToggle() {
        const expanded = this.classList.toggle('is-expanded');
        this._toggle.setAttribute('aria-expanded', String(expanded));

        const more = this._toggle.querySelector('[data-label-more]');
        const less = this._toggle.querySelector('[data-label-less]');
        if (more && less) {
          more.hidden = expanded;
          less.hidden = !expanded;
        }
      }
    }
  );
}
